import { type PropsWithChildren } from 'react';
import type enMessages from '@/messages/en.json';
import { messages } from '@/i18n/messages';
import { NextIntlClientProvider } from 'next-intl';

export const appLocale = 'en' as const;

declare module 'next-intl' {
  interface AppConfig {
    Locale: typeof appLocale;
    Messages: typeof enMessages;
  }
}

export const AppI18nProvider = ({ children }: PropsWithChildren) => (
  <NextIntlClientProvider locale={appLocale} messages={messages} timeZone={'UTC'}>
    {children}
  </NextIntlClientProvider>
);
